"use client";

import { c as _c } from "react/compiler-runtime";
import { locale } from "@locale";
import type { SanityReference } from "next-sanity";
import { useState } from "react";
import Ad from "src/components/ads/Ad";
import Button from "src/components/button/Button";
import MoviesByMonth from "src/components/kommendefilmer/MoviesByMonth";
import PremieresThisWeek from "src/components/kommendefilmer/PremieresThisWeek";
import UpcomingMoviesLoader from "src/components/kommendefilmer/UpcomingMoviesLoader";
import PosterListSvg from "src/components/svg/PosterListSvg";
import TextListSvg from "src/components/svg/TextListSvg";
import TopOfPageSponsor from "src/components/takoversponsor/TopOfPageSponsor";
import styles from "./KommerPåKinoContent.module.css";
import type AdUnitWithPosition from "src/components/forsiden/AdUnitWithPosition";
import { formatLocaleStringWithLink } from "src/lib/locale/helpers";
type KommerPåKinoContentProps = {
  hasSponsor: boolean;
  dynamicAdKeys: string[];
  ads?: AdUnitWithPosition[];
  sponsorTopImageMobile: SanityReference[] | null;
  sponsorTopImageDesktop: SanityReference[] | null;
  sponsorClickUrl: string | null;
};
export default function KommerPåKinoContent(t0) {
  const $ = _c(35);
  const {
    hasSponsor,
    dynamicAdKeys,
    ads,
    sponsorTopImageMobile,
    sponsorTopImageDesktop,
    sponsorClickUrl
  } = t0;
  const [isPosterList, setIsPosterList] = useState(true);
  let t1;
  if ($[0] !== ads) {
    t1 = ads?.find(_temp);
    $[0] = ads;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const adsBeforeMonths = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h1 className={styles.SPageTitle}>{locale.kommer.heading}</h1>;
    t3 = locale.kommer.subHeading && <p>{formatLocaleStringWithLink(locale.kommer.subHeading)}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isPosterList) {
    t4 = () => setIsPosterList(!isPosterList);
    $[4] = isPosterList;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isPosterList ? locale.kommer.viewText : locale.kommer.viewPoster;
  let t6;
  if ($[6] !== isPosterList) {
    t6 = isPosterList ? <TextListSvg className={styles.STextListSvg} /> : <PosterListSvg className={styles.SPosterListSvg} />;
    $[6] = isPosterList;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className={styles.SViewToggleContainer}><Button onClick={t4} text={t5} icon={t6} /></div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== hasSponsor || $[13] !== sponsorClickUrl || $[14] !== sponsorTopImageDesktop || $[15] !== sponsorTopImageMobile) {
    t8 = hasSponsor && <TopOfPageSponsor className={styles.STopOfPageSponsor} mobileImages={sponsorTopImageMobile} desktopImages={sponsorTopImageDesktop} clickUrl={sponsorClickUrl} />;
    $[12] = hasSponsor;
    $[13] = sponsorClickUrl;
    $[14] = sponsorTopImageDesktop;
    $[15] = sponsorTopImageMobile;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <header className={styles.SPageHeader}>{t2}{t3}{t7}{t8}</header>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = !isPosterList;
  let t11;
  if ($[20] !== t10) {
    t11 = <PremieresThisWeek showTextList={t10} />;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== adsBeforeMonths) {
    t12 = adsBeforeMonths && <Ad targetId={adsBeforeMonths.targetId} removeIfNoAd={true} mobileScreenWidth={true} />;
    $[22] = adsBeforeMonths;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = !isPosterList;
  let t14;
  if ($[24] !== dynamicAdKeys || $[25] !== t13) {
    t14 = <MoviesByMonth adKeys={dynamicAdKeys} showTextList={t13} />;
    $[24] = dynamicAdKeys;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Ad targetId="FW_parallax_bunn1_kommende" removeIfNoAd={true} supportsFixedAd={true} height="300" mobileScreenWidth={true} />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t14) {
    t16 = <UpcomingMoviesLoader>{t11}{t12}{t14}{t15}</UpcomingMoviesLoader>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t14;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16 || $[33] !== t9) {
    t17 = <>{t9}{t16}</>;
    $[32] = t16;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
}
function _temp(a) {
  return a.position === 0;
}